import api from './api';

const BASE = '/api/seven-gen';

export const getPlans       = (params)   => api.get(BASE, { params });
export const getPlan        = (id)       => api.get(`${BASE}/${id}`);
export const createPlan     = (data)     => api.post(BASE, data);
export const updatePlan     = (id, data) => api.put(`${BASE}/${id}`, data);
export const deletePlan     = (id)       => api.delete(`${BASE}/${id}`);
export const synthesizePlan = (id, data) => api.post(`${BASE}/${id}/synthesize`, data);
